import { IEditMeetingOrderData } from "../../../../Types/MeetingPlanning/deliveryForm"

export enum MeetingPlanningEditOrderActionTypes {
    EDIT_ORDER = "meetingPlanning/EDIT_ORDER",
}

export type EditMeetingOrder = Readonly<{
    type: MeetingPlanningEditOrderActionTypes.EDIT_ORDER
    payload: IEditMeetingOrderData | null
}>

export const editMeetingOrder = (payload: IEditMeetingOrderData | null): EditMeetingOrder => ({
    type: MeetingPlanningEditOrderActionTypes.EDIT_ORDER,
    payload
})

export type MeetingPlanningEditOrderAction =
    | EditMeetingOrder
